module.exports = __webpack_public_path__ + "img/3.b57ce231.jpg";